import { Flex, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	signaturesOutstanding: number;
	signersNeedingAssignment: number;
	signed: number;
	total: number;
}

export const DocumentSignersBanner = ({
	signaturesOutstanding,
	signersNeedingAssignment,
	signed,
	total,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	if (signaturesOutstanding === 0 && signersNeedingAssignment === 0) {
		return null;
	}

	return (
		<Flex
			align="center"
			gap="0.5rem"
			p="0.5rem 0.75rem"
			style={{
				borderRadius: '0.25rem',
				border: `1px solid ${defaultTheme.v3.colors.orange[3]}`,
			}}
		>
			<Icon variant="warning" size="lg" color={defaultTheme.v3.colors.orange[6]} />

			<Flex style={{ flex: 1 }} gap="0.25rem" align="center" wrap="wrap">
				<Text fw={600} size="0.875rem" lh="1.25rem" c={defaultTheme.v3.colors.black[0]}>
					{tMipManage('documents_page.banner.signatures_outstanding', {
						count: signaturesOutstanding,
					})}
				</Text>
				{signersNeedingAssignment > 0 && (
					<Text size="0.875rem" lh="1.25rem" c={defaultTheme.v3.colors.dark[0]}>
						{tMipManage('documents_page.banner.signers_needing_assignment', {
							count: signersNeedingAssignment,
						})}
					</Text>
				)}
			</Flex>

			<Flex align="center" gap="0.5rem" style={{ flexShrink: 0 }}>
				<Text fw={600} size="0.875rem" lh="1.25rem" c={defaultTheme.v3.colors.black[0]}>
					{signed}/{total}
				</Text>
			</Flex>
		</Flex>
	);
};
